module.exports = __webpack_public_path__ + "static/Number-1-ceeeb7a4145ff8037967e3bed5352024.png";